<template>
  <Page type="no-header">

      <List />
  </Page>
</template>

<script>
import Page from '@/components/visual/Page'
import List from '@/components/calendar/List'

export default {
    components: { Page, List },
    data() {
      return {
      }
    },
}
</script>

<i18n locale="ru" lang="yaml">
  pageTitle: "Календарь"
</i18n>

<i18n locale="en" lang="yaml">
  pageTitle: "Calendar"
</i18n>
